export default "<div class=\"extra-div\"></div>\r\n<app-contact></app-contact>\r\n"